import { Tooltip, Typography } from "@mui/material";
import { StyledFlex } from "../../../styled/flex";
import { StyledFormHeader } from "../../../styled/form";

const NewFormHeader = ({ formName, handleClose, loading }) => {
  return (
    <StyledFormHeader.Container>
      <StyledFlex.Title>
        <Typography sx={StyledFormHeader.text}>
          INGRESANDO: {formName}
        </Typography>
      </StyledFlex.Title>
      {handleClose &&
        <Tooltip title="Cerrar">
          <StyledFormHeader.CloseIcon onClick={handleClose} disabled={loading} />
        </Tooltip>
      }

    </StyledFormHeader.Container>
  );
};

export default NewFormHeader;
